
















































import { Component, Prop, Vue } from "vue-property-decorator";

import Simplebar from "simplebar-vue";

import { dateFormat } from "@/utils/setFormatDate";
import WeekSwitcher from "@/components/Table/WeekSwitcher/WeekSwitcher.vue";
import Card from "@/components/Card/Card.vue";
import { TODAY } from "@/App.vue";
import { DataItem, DataWeeks } from "@/data.model";

export enum Week {
  Current,
  Next
}

const DAYS = [
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
  "Воскресенье"
];

const getDate = (date: string): number => {
  const match = date.match(/[0-9]+$/);

  if (match === null) {
    console.error("Ошибка! Невозможно получить дату начала недели");
    return 0;
  }

  return +match[0];
};

@Component({
  components: {
    Simplebar,
    WeekSwitcher,
    Card
  }
})
export default class TableView extends Vue {
  @Prop() readonly items!: DataItem[];
  @Prop() readonly weeks!: DataWeeks;

  activeWeek = Week.Current;
  today = dateFormat.YYYY_MM_DD_2(TODAY);

  get weekDays() {
    const startDate = this.weeks[0];
    const dayDate = getDate(startDate);
    const tempDate = new Date(startDate);

    const getDays = (isNextWeek = false) =>
      DAYS.map((day, index) => {
        const date = tempDate;
        let newDate = dayDate + index;

        if (isNextWeek) {
          newDate += 7;
        }

        date.setDate(newDate);

        return {
          name: day,
          date: dateFormat.YYYY_MM_DD_2(date),
          day: dateFormat.D_DDDD(date)
        };
      });

    return [
      getDays(), // current
      getDays(true) // next
    ];
  }

  get weekStart() {
    return this.weekDays[this.activeWeek][0].date
      .split("-")
      .reverse()
      .join(".");
  }

  get weekEnd() {
    const lastIndex = this.weekDays[this.activeWeek].length - 1;
    return this.weekDays[this.activeWeek][lastIndex].date
      .split("-")
      .reverse()
      .join(".");
  }

  setActiveWeek(value: Week) {
    this.activeWeek = value;
  }
}
